var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{staticStyle:{"flex":"none"},attrs:{"id":"app-bar","app":"","flat":"","height":"0","color":_vm.$store.state.socio.cor}},[_c('v-spacer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }